var App = App || {};

App.TabbedContentBandMobile = (function ($) {
    'use strict';

    var Bps = ["xs", "sm", "md"],
        Bp = ZAGFramework.GetCurrentBP();

    function Init() {
        const tabbedContentBand = $(".widget.widget-tabbed-content-band");

        if (tabbedContentBand.length) {
            tabbedContentBand.each(function () {
                const thisBand = $(this);
                const tabBtns = thisBand.find(".nav-link");

                App.Base.SwipeInit(thisBand);

                moveIndicator(thisBand);

                tabBtns.on('shown.bs.tab', function (event) {
                    moveIndicator(thisBand);
                })

                //indicate correct tab on mobile breakpoint transition
                var wasMobile = Bps.includes(Bp);
                $(window).on("resize", function () {
                    Bp = ZAGFramework.GetCurrentBP();
                    if (Bps.includes(Bp)) {
                        wasMobile = true;
                    } else {
                        if (wasMobile) {
                            //entering desktop
                            moveIndicator(thisBand);
                        }
                        wasMobile = false;
                    }
                });
            });
        }

    }

    function moveIndicator(thisBand) {
        const indicator = thisBand.find(".nav-tab-indicator"),
            activeTab = thisBand.find(".nav-link.active");
        indicator.css("max-height", activeTab.outerHeight());
        indicator.css("transform", "translateY(" + activeTab.position().top + "px)")
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.TabbedContentBandMobile.Init();
});